import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/context/AuthContext'
import { CurrentInstituteProvider } from '@/context/CurrentInstituteContext'
import { RoleProvider } from '@/context/RoleContext'
import { ErrorBoundary } from '@/components/ErrorBoundary'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,        // 1 minute
      gcTime: 5 * 60_000,       // 5 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

/**
 * Global provider stack: ErrorBoundary → QueryClientProvider → AuthProvider.
 *
 * Configures React Query with 1-minute stale time, 5-minute GC, 2 retries,
 * and no refetch-on-focus. All child components receive auth context and
 * query cache.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider><CurrentInstituteProvider><RoleProvider>{children}</RoleProvider></CurrentInstituteProvider></AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
